import { Helmet } from 'react-helmet-async';
import DashboardHeader from 'src/components/accounts-management/dashboard-Header';
import Dashboard from './accounts-dashboard';
import { useSearchParams } from 'src/routes/hooks';
import { useEffect, useState } from 'react';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
// ----------------------------------------------------------------------
export default function AccountsDashboard() {
  const [data, setData] = useState([]);
  console.log('><><>>><>>><>', data);

  const searchParams = useSearchParams();
  const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
  const project = searchParams.get('project_id') || localStorage.getItem('projectId') || '';
  const company = searchParams.get('company_id') || localStorage.getItem('companyId') || '';
  useEffect(() => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('projectId', project);
    localStorage.setItem('companyId', company);
  }, [token]);

  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getDashboardDetails = async () => {
    const response = await getRequest(endpoints.accounting.dashboard.get_details);
    console.log('🚀 ~    ~ response:', response);
    setData(response);
  };

  return (
    <>
      <Helmet>
        <title>Accounts</title>
      </Helmet>
      <DashboardHeader Title="Accounting Dashboard" />
      <Dashboard data={data} />
    </>
  );
}
